/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../pages/Login";
import ForgotPassword from "../pages/forgotPassword";
import ResetPassword from "../pages/resetPassword";
import ActivateAccount from "../pages/activateAccount";
import Home from "../pages/dashboard/Home";
import Users from "../pages/dashboard/Users";
import Report from "../pages/dashboard/Report";
import NotFound from "../pages/NotFound"
import { refreshToken } from "../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import PrivateRoute from "../components/PrivateRoute";
function WebRoutes() {
  const dispatch = useDispatch();
  const { refresh_token } = useSelector((state) => state.auth);
  const refreshAuthToken = async () => {
    try {
      await dispatch(refreshToken()); // Ensure dispatch returns a promise
    } catch (error) {
      console.error('Error refreshing token:', error);
    }
  };
  useEffect(() => {
    if (refresh_token) {
      // Set up the interval to refresh the token every 5 minutes (300,000 milliseconds)
      
      const interval = setInterval(() => {
        refreshAuthToken();
      }, 120000);// 300000 ms = 5 minutes     

      // Clean up the interval on component unmount
      return () => clearInterval(interval);
    }
  }, [dispatch, refresh_token]);


    return (
        <Routes>
          <Route path="/notfound" element={<NotFound />} />
          <Route path="*" element={<Navigate to='/' />} />
          <Route path="/login" element={<Login />} />
          <Route path="/account/activate/:activatekey" element={<ActivateAccount />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/account/reset-password/:code" element={<ResetPassword />} />
          <Route path="/" element={<PrivateRoute >
            <Home />
          </PrivateRoute>} />
          <Route path="/home" element={<PrivateRoute ><Home /></PrivateRoute>} />
          <Route path="/users" element={<PrivateRoute ><Users /></PrivateRoute>} />
          <Route path="/report" element={<PrivateRoute ><Report /></PrivateRoute>} />
          {/* <Route path="/login" element={<PrivateRoute >
              <Login />
            </PrivateRoute>}  />
          <Route index element={<PrivateRoute >
              <Home />
            </PrivateRoute>} />
            <Route path="/" element={<PrivateRoute >
              <Home />
            </PrivateRoute>} />
          <Route path="/home"  element={<PrivateRoute >
            <Home />
          </PrivateRoute>} /> */}
         
           {/*
    
            <Route path="/login" element={<Login />} />
            <Route path="/registration" element={<Registration />} />
            
            <Route
              path="/resetpassword/:email/:token"
              element={<ResetPassword />}
            />  */}
          {/* </Route> */}
    
        </Routes>
      );
}

export default WebRoutes;